import { MenuItem } from "../../Types/Layout/SidebarType";


export const MenuList: MenuItem[] = [
  {
    title: "General",
    lanClass: "lan-1",
    Items: [
      {
        title: "Dashboard",
        icon: "home",
        type: "link",
        lanClass: "lan-3",
        path: `/`,
      },

    ]
  },
  {
    title: "Reports",
    lanClass: "lan-8",
    Items: [
      {
        title: "All Reports",
        id: 4,
        icon: "layout",
        type: "link",
        path: `/report/list`,
        active: false,

      },
      {
        title: "Templates",
        id: 4,
        icon: "layout",
        type: "link",
        path: `/template/list`,
        active: false,

      },
    ]
  },

  {
    title: "Patients",
    lanClass: "lan-8",
    Items: [
      {
        title: "Manage Patients",
        id: 4,
        icon: "user",
        type: "link",
        path: `/patient/list`,
        active: false,

      },
    ]
  },

  {
    title: "User Settings",
    lanClass: "lan-8",
    Items: [
      {
        title: "Account Settings",
        id: 5,
        icon: "knowledgebase",
        type: "sub",
        children: [
          { path: `/user/edit_profile`, type: "link", title: "Edit Profile" },
          { path: `/user/reset_password`, type: "link", title: "Reset Password" },
        ],
      },
      {
        title: "Feedback",
        id: 6,
        icon: "email",
        type: "link",
        path: `/user/feedback`,
      },
    ]
  },
  // {
  //   title: "Personalized Videos",
  //   lanClass: "lan-8",
  //   Items: [
  //     {
  //       title: "Generate Videos",
  //       id: 3,
  //       icon: "project",
  //       type: "sub",
  //       active: false,
  //       children: [
  //         { path: `/video/list`, type: "link", title: "Video-List" },
  //         { path: `/video/create_new`, type: "link", title: "Create New" },
  //       ],
  //     },
  //     {
  //       title: "Video Template",
  //       id: 4,
  //       icon: "file",
  //       type: "sub",
  //       active: false,
  //       children: [
  //         { path: `/template/list`, type: "link", title: "Template-List" },
  //         { path: `/template/upload_new`, type: "link", title: "Upload template" },
  //       ],
  //     },

  //   ]
  // },

];

export const AdminMenuList: MenuItem[] = [
  {
    title: "General",
    lanClass: "lan-1",
    Items: [
      {
        title: "Clinicians",
        icon: "user",
        type: "link",
        lanClass: "lan-3",
        path: `/`,
      },
      {
        title: "Patients",
        icon: "user",
        type: "link",
        lanClass: "lan-3",
        path: `/admin/patients`,
      },
      {
        title: "Reports",
        icon: "layout",
        type: "link",
        lanClass: "lan-3",
        path: `/admin/reports`,
      },
      {
        title: "Templates",
        icon: "layout",
        type: "link",
        lanClass: "lan-3",
        path: `/admin/templates`,
      },
    ]
  },
  {
    title: "Settings",
    lanClass: "lan-8",
    Items: [
      {
        title: "Account Settings",
        id: 5,
        icon: "knowledgebase",
        type: "sub",
        children: [
          { path: `/user/edit_profile`, type: "link", title: "Edit Profile" },
          { path: `/user/reset_password`, type: "link", title: "Reset Password" },
        ],
      },

    ]
  },

];